import { MixedObject } from '@app/core/interfaces/mixed-object';
import { camelCase, forEach, isArray, isObject, isPlainObject, kebabCase, lowerCase, snakeCase, startCase, upperCase } from 'lodash';

export const classOf = <T>(o: T): any => {
  return o.constructor;
};

export const getRandomInt = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1)) + min;

export declare type stringCase = 'camel' | 'snake' | 'kebab' | 'lower' | 'start' | 'upper';

export const objectKeysToSelectedCase = (
  obj: object | any[],
  toCase: stringCase,
  asArray = false,
  keepDashAtStart = false
) => {
  const parsedObj: MixedObject = {};
  const arr: any[] = [];
  forEach(
    obj,
    (value: any, key: string) => {
      if (isPlainObject(value) || isObject(value) && !isArray(value)) {
        value = objectKeysToSelectedCase(value, toCase, false, keepDashAtStart);
      }

      if (isArray(value)) {
        value = objectKeysToSelectedCase(value, toCase, true, keepDashAtStart);
      }

      if (asArray) {
        arr[key] = value;
      } else {
        let parsedKey = '';
        let prefix = '';

        if (key.startsWith('--')) {
          prefix = '--';
        } else if (key.startsWith('-')) {
          prefix = '-';
        }

        switch (toCase) {
          case 'camel':
            parsedKey = camelCase(key);
            break;
          case 'snake':
            parsedKey = snakeCase(key);
            break;
          case 'kebab':
            parsedKey = kebabCase(key);
            break;
          case 'lower':
            parsedKey = lowerCase(key);
            break;
          case 'start':
            parsedKey = startCase(key);
            break;
          case 'upper':
            parsedKey = upperCase(key);
            break;
        }

        parsedKey = prefix + parsedKey;
        parsedObj[parsedKey] = value;
      }
    }
  );
  return asArray ? arr : parsedObj;
};

export const isFullyVisible = (element: any): boolean => {
  const position = element.getBoundingClientRect();
  // checking whether fully visible
  return position.top >= 0 && position.bottom <= (window?.pageYOffset || 0);
};

export const whatPercentOf = (part: number, full: number): number => {
  return Number(((part / full) * 100).toFixed(2));
};
export const getValueFromPercentageOf = (percentage: number, full: number): number => {
  return Number(((percentage / 100) * full).toFixed(2));
};

export const findParentByTagName = (el, parentTagName) => {
  let element: any;
  element = el;

  while (element?.parentNode) {
    element = element?.parentNode;
    if (element.tagName.toLowerCase() === parentTagName.toLowerCase()) {
      return element;
    }
  }
  return null;
};

export const roundTo2Decimals = (value: string | number): number => {
  return Math.round(Number(value) * 100) / 100;
};

export const chunkArray = (array: any[], size: number) => {
  return Array.from({length: Math.ceil(array.length / size)}, (v, i) =>
    array.slice(i * size, i * size + size)
  );
};
